"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RutterConfigOutSerializer = void 0;
exports.RutterConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=rutterConfigOut.js.map